import { type Unit, type Pixel, SourceType } from '@/data';
import type { MetadataFormat } from '@/data/Metadata';
import type Metadata from '@/data/Metadata';
import { type Image3DPageData, ImageLikeSource } from '@/data/sources';

export interface StructureDataToParse extends MetadataFormat {
  structure?: unknown;
  name?: string;
  id?: string;
  pixelUnit: Unit<Pixel>;
  width: Pixel;
  height: Pixel;
  pages?: Array<Image3DPageData>;
  metadata: Metadata;
  svgImage: string;
}

export class Structure extends ImageLikeSource {
  svgImage: string;

  constructor(parsed: StructureDataToParse) {
    super({
      pixelUnit: parsed.pixelUnit,
      type: SourceType.Structure,
      width: parsed.width,
      height: parsed.height,
      pages: parsed.pages,
      metadata: parsed.metadata,
      name: parsed.name,
      isLinear: false,
    });
    this.svgImage = parsed.svgImage;
  }

  scaled(scale: number): ImageLikeSource {
    throw new Error(`Method not implemented. scale = ${scale}`);
  }
}
